import React, { useMemo } from 'react';
import bem from 'utils/bem';
import Page from '../Page';
import Text from 'components/Text';

export const NoFilesPlaceholder = ({className}) => {
    const { block, el } = useMemo(() => bem(className), [className]);

    return (
        <Page className={ block() }>
            <div className={ el('content') }>
                <div className={ el('info') }>
                    <Text>{ `Курс не содержит материалов` }</Text>
                </div>
            </div>
        </Page>
    )
}
